import clsx from "clsx";
import type { ReactNode } from "react";

// The "polaroid" from the Figma: cream body, 2px brown border, hard shadow,
// with an optional framed media well at the top.
export default function Card({
  media,
  children,
  className,
  bodyClassName,
  interactive = false,
}: {
  media?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  interactive?: boolean;
}) {
  return (
    <div
      className={clsx(
        "border-line bg-surface shadow-card flex h-full flex-col border-2",
        interactive &&
          "duration-fast ease-standard transition-transform hover:-translate-y-1",
        className,
      )}
    >
      {media && (
        <div className="border-line bg-surface-alt m-4 mb-0 overflow-hidden border">
          {media}
        </div>
      )}
      <div className={clsx("flex flex-1 flex-col p-5", bodyClassName)}>
        {children}
      </div>
    </div>
  );
}
